export const isIOS = () => {
  const win = typeof window !== 'undefined' ? (window as any) : { navigator: { userAgent: '' } }

  return /iPad|iPhone|iPod/.test(win.navigator.userAgent) && !win.MSStream
}
